import { render, staticRenderFns } from "./SgaFrases.vue?vue&type=template&id=7ca33e1e&scoped=true"
import script from "./SgaFrases.vue?vue&type=script&lang=js"
export * from "./SgaFrases.vue?vue&type=script&lang=js"
import style0 from "./SgaFrases.vue?vue&type=style&index=0&id=7ca33e1e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ca33e1e",
  null
  
)

export default component.exports